import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://9f6e9e870e04195965d0d9024dd7eba5@o4511418068697088.ingest.de.sentry.io/4512265188606032",
});